export default __webpack_public_path__ + "static/logos-tiles-pmi-6d855744f604d32d44ca4dbe37c1d65a.svg";